import * as defaultLoggerFactory from '@wix/web-bi-logger/dist/src/logger';

var Reporter = /*#__PURE__*/function () {
  function Reporter(_ref) {
    var biLoggerFactory = _ref.biLoggerFactory,
        baseUrl = _ref.baseUrl,
        preset = _ref.preset,
        useBatch = _ref.useBatch;
    this._preset = preset;
    var shouldBatch = !(useBatch === false);
    this._factory = biLoggerFactory || defaultLoggerFactory.factory({
      host: baseUrl,
      useBatch: shouldBatch
    });
    this._publisher = this._factory.logger();
  }

  var _proto = Reporter.prototype;

  _proto.flush = function flush() {
    this._publisher.flush();
  };

  _proto.report = function report(data, reporterEndpoint) {
    if (!data) {
      return null;
    }

    var endpoint = reporterEndpoint || this._preset.nonPersistentEndpoint;
    return this._publisher.log(data, {
      endpoint: endpoint,
      category: 'essential'
    });
  };

  return Reporter;
}();

export { Reporter as default };